<vw-header-padding-safe-area></vw-header-padding-safe-area>
<div class="px-4">
  <vw-header-home [user]="user"></vw-header-home>
  <div class="pb-6 w-full">
    <div class="flex flex-col gap-2">
      <!-- Wait for user to be loaded to be sure that address-uid is set to localstorage -->
      @if (userLoaded) {
      <vw-garden-today-card [advice]="advice"></vw-garden-today-card>
      }
      @if (!userLoaded) {
      <vw-skeleton-loader [width]="'100%'" [height]="'50px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
      }
      @if (userLoaded) {
        <vw-alerts-banner (bannerClick)="onNotificationsClicked()"></vw-alerts-banner>
      }
      <div [style.background-color]="'#9AD6AD' | HexToHsl" (click)="onFeedbackClicked()"
        class="shadow-lg rounded-xl w-full relative overflow-hidden h-12 flex items-center justify-between cursor-pointer">
        <vw-chevron-right-icon
          class="transition-transform duration-300 absolute right-3 top-1/2 -translate-y-1/2 text-[#093935]" />
        <div class="h-full flex items-center px-4 gap-2">
          <div class="w-8 flex items-center justify-center shrink-0 h-5">
            <vw-message-circle-question-icon class="text-[#093935] h-5" />
          </div>
          <p class="text-sm font-medium whitespace-normal text-[#093935]">
            {{ 'home.feedback.title' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="pb-6 w-full">
    <h2 class="text-primary-title text-2xl font-semibold pb-2">
      {{ "home.tasks.title" | translate }}
    </h2>
    @if (tasks?.length === 0) {
      <div class="text-grey-700">{{ "home.tasks.unavailable" | translate }}</div>
    }
    @for (task of tasks; track task) {
      <div>
        <vw-task [task]="task"></vw-task>
      </div>
    }
  </div> -->

  <!-- Today's advice: weather/lunar triggers × the user's growing plants -->
  @if (advice && advice.advices.length > 0) {
  <div class="pb-6 w-full flex flex-col gap-2">
    <vw-garden-advices-widget [advice]="advice"></vw-garden-advices-widget>
    <!-- Juste sous les conseils : l'utilisateur vient de constater ce que
         l'app sait faire, c'est le seul moment où l'offre a du sens. -->
    @if (showTeasers) {
    <vw-premium-teaser
      [message]="'premium.teaser.lunar' | translate"
      [detail]="'premium.teaser.lunar-detail' | translate"
      source="home_advices"
      (ctaClicked)="openPaywall($event)"
    ></vw-premium-teaser>
    }
  </div>
  }

  <div class="pb-2 w-full">
    @if (hierarchies?.length === 0 && !isLoading) {
    <div class="flex flex-col gap-2">
      <h2 class="text-primary-title text-2xl font-semibold">
        {{ "home.cultivations.empty-title" | translate }}
      </h2>
      <p class="text-grey-600">{{ "home.cultivations.empty" | translate }}</p>
      <div class=" w-full flex flex-col gap-4 items-center">
        <vw-icon-svg [iconUrl]="'assets/images/plant/empty-hierarchies.png'" width="50%"
          class="flex justify-center"></vw-icon-svg>
        <vw-button [label]="'home.cultivations.addPlant'" (click)="onAddPlant()">
        </vw-button>
      </div>
    </div>
    }
    @if (hierarchies?.length > 0 && !isLoading) {
    <div>
      <h2 class="text-primary-title text-2xl font-semibold pb-2">
        {{ "home.cultivations.title" | translate }}
      </h2>
      <vw-user-hierarchies [hierarchies]="hierarchies" [isLoading]="isLoading"></vw-user-hierarchies>
    </div>
    }

    <!-- GDD milestones (in-progress plants) -->
    @if (gddMilestones.length > 0) {
    <div class="mt-8 flex flex-col gap-2">
      <vw-gdd-milestones-widget [items]="gddMilestones"></vw-gdd-milestones-widget>
      <!-- La progression est visible, la date de récolte ne l'est pas :
           l'encart répond à la question que l'écran vient de poser. -->
      @if (showTeasers) {
      <vw-premium-teaser
        [message]="'premium.teaser.harvest' | translate"
        [detail]="'premium.teaser.harvest-detail' | translate"
        source="home_gdd"
        (ctaClicked)="openPaywall($event)"
      ></vw-premium-teaser>
      }
    </div>
    }

    <!-- Articles  -->
    @if (articles?.length > 0) {
    <div class="flex flex-col gap-4 mt-8 mb-28">
      <h2 class="text-primary-title text-2xl font-semibold">
        {{ "home.articles.title" | translate }}
      </h2>
      @for (article of articles; track article) {
      <vw-article [article]="article"></vw-article>
      }
    </div>
    }
  </div>

</div>

<vw-feedback-modal [isOpen]="isFeedbackModalOpen" (onModalClosed)="isFeedbackModalOpen = false"></vw-feedback-modal>

<vw-premium-toast
  [isOpen]="premiumPaywallMode"
  [source]="paywallSource"
  (close)="premiumPaywallMode = false"
></vw-premium-toast>
<!-- <vw-report-modal [isOpen]="true"></vw-report-modal> -->